import { useEffect as e } from "react";
import { throttle as t } from "es-toolkit/function";
//#region src/hooks/useWindowResize.ts
var n = (n, r = 300) => {
	e(() => {
		let e = t(n, r);
		return window.addEventListener("resize", e, { passive: !0 }), () => {
			window.removeEventListener("resize", e);
		};
	}, [n, r]);
};
//#endregion
export { n as default };

//# sourceMappingURL=useWindowResize.js.map